import Button from 'components/Basic/Button';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { toggleSettingsModal } from 'store/slices/DesignSettingsSlice';
import Settings from '.';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';
import { selectIsAnyToolActionActive } from 'store/selectors/toolSelector';

export default function SettingsBtn(){
	const disptach = useDispatch<AppDispatch>();
	const hideSatelliteOverlay = useSelector((state: RootState) => state.toolNewPostions.data.hideSatelliteOverlay);
	const isAnyToolActionActive = useSelector(selectIsAnyToolActionActive);
	const disableSettingBtn = useSelector(selectIsRecomputing) || hideSatelliteOverlay || isAnyToolActionActive;
	return (
		<>
			<Button
				id="settings"
				className='btnHover'
				onClick={() => {
					disptach(toggleSettingsModal({ open: true }));
				}}
				disabled={disableSettingBtn}
				tooltipContent='Settings'
			>
				<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 15H11M11 15C11 16.1046 11.8954 17 13 17C14.1046 17 15 16.1046 
						15 15M11 15C11 13.8954 11.8954 13 13 13C14.1046 13 15 13.8954 15 15M15 
						15H17M17 9H7M7 9C7 10.1046 6.10457 11 5 11C3.89543 11 3 10.1046 3 
						9M7 9C7 7.89543 6.10457 7 5 7C3.89543 7 3 7.89543 3 9M3 9H1M1 3H11M11 
						3C11 4.10457 11.8954 5 13 5C14.1046 5 15 4.10457 15 3M11 3C11 1.89543 11.8954 1 13 1C14.1046 1 15 1.89543 15 3M15 3H17" 
					stroke="var(--defaultIconColor)" 
					strokeWidth="1.6" 
					strokeLinecap="round" 
					strokeLinejoin="round" />
				</svg>
			</Button>
			<Settings/>
		</>
	);
}